export const States = [
  { long: 'Alabama', abrv: 'AL' },
  { long: 'Alaska', abrv: 'AK' },
  { long: 'Arizona', abrv: 'AZ' },
  { long: 'Arkansas', abrv: 'AR' },
  { long: 'California', abrv: 'CA' },
  { long: 'Colorado', abrv: 'CO' },
  { long: 'Connecticut', abrv: 'CT' },
  { long: 'Delaware', abrv: 'DE' },
  { long: 'District of Columbia', abrv: 'DC' },
  { long: 'Florida', abrv: 'FL' },
  { long: 'Georgia', abrv: 'GA' },
  { long: 'Guam', abrv: 'GU' },
  { long: 'Hawaii', abrv: 'HI' },
  { long: 'Idaho', abrv: 'ID' },
  { long: 'Illinois', abrv: 'IL' },
  { long: 'Indiana', abrv: 'IN' },
  { long: 'Iowa', abrv: 'IA' },
  { long: 'Kansas', abrv: 'KS' },
  { long: 'Kentucky', abrv: 'KY' },
  { long: 'Louisiana', abrv: 'LA' },
  { long: 'Maine', abrv: 'ME' },
  { long: 'Maryland', abrv: 'MD' },
  { long: 'Massachusetts', abrv: 'MA' },
  { long: 'Michigan', abrv: 'MI' },
  { long: 'Minnesota', abrv: 'MN' },
  { long: 'Mississippi', abrv: 'MS' },
  { long: 'Missouri', abrv: 'MO' },
  { long: 'Montana', abrv: 'MT' },
  { long: 'Nebraska', abrv: 'NE' },
  { long: 'Nevada', abrv: 'NV' },
  { long: 'New Hampshire', abrv: 'NH' },
  { long: 'New Jersey', abrv: 'NJ' },
  { long: 'New Mexico', abrv: 'NM' },
  { long: 'New York', abrv: 'NY' },
  { long: 'North Carolina', abrv: 'NC' },
  { long: 'North Dakota', abrv: 'ND' },
  { long: 'Ohio', abrv: 'OH' },
  { long: 'Oklahoma', abrv: 'OK' },
  { long: 'Oregon', abrv: 'OR' },
  { long: 'Pennsylvania', abrv: 'PA' },
  { long: 'Rhode Island', abrv: 'RI' },
  { long: 'South Carolina', abrv: 'SC' },
  { long: 'South Dakota', abrv: 'SD' },
  { long: 'Tennessee', abrv: 'TN' },
  { long: 'Texas', abrv: 'TX' },
  { long: 'Utah', abrv: 'UT' },
  { long: 'Vermont', abrv: 'VT' },
  { long: 'Virginia', abrv: 'VA' },
  { long: 'Washington', abrv: 'WA' },
  { long: 'West Virginia', abrv: 'WV' },
  { long: 'Wisconsin', abrv: 'WI' },
  { long: 'Wyoming', abrv: 'WY' }
];

export const CentersIds = [
  {
    label: 'Alabama',
    value: 'a7513733-92a6-4811-b048-194c113427e6'
  },
  {
    label: 'Alaska',
    value: 'd82e7191-2d17-46a2-831e-d7acda6e3336'
  },
  {
    label: 'Arizona',
    value: '67985391-56f1-4ee4-b321-d76988f5ab14'
  },
  {
    label: 'Arkansas',
    value: 'b61b759e-ace0-4eff-94ad-c27055de0c1e'
  },
  {
    label: 'California',
    value: '6a5d047d-9c0b-43ae-ab54-f166cfb655f4'
  },
  {
    label: 'Colorado',
    value: 'dc6bd825-99b7-4456-89c5-fd6c793c14b8'
  },
  {
    label: 'Connecticut',
    value: '14412bae-9efd-4e27-ac8b-5462723bea87'
  },
  {
    label: 'Delaware',
    value: '07c3b394-5aa4-4ab4-bfe5-795399ee9b8d'
  },
  {
    label: 'District of Columbia',
    value: '7daf0b47-f448-4a48-ae51-53d6e7fa7264'
  },
  {
    label: 'Florida',
    value: 'a23ae785-32cc-4b06-bca7-bd9118c9d27b'
  },
  {
    label: 'Georgia',
    value: '3eb2271f-bcd4-4710-b2dd-0dda5dee4336'
  },
  {
    label: 'Hawaii',
    value: '4cce36e8-94c6-4c60-a464-d1e96f35aa35'
  },
  {
    label: 'Idaho',
    value: 'f24c98cd-ecf4-4284-8e4f-128a7c2a44e8'
  },
  {
    label: 'Illinois',
    value: '68192400-d338-4511-ac24-0d6a8f22a4e1'
  },
  {
    label: 'Indiana',
    value: '1ca1fa5b-9dac-4b91-98f0-20dd581b601e'
  },
  {
    label: 'Iowa',
    value: 'caf70750-ab12-447a-929c-ed6fbfb420c2'
  },
  {
    label: 'Kansas',
    value: '2740f7aa-2699-43e4-8683-f964f241c3ad'
  },
  {
    label: 'Kentucky',
    value: '6244949c-b0d7-41f7-8d84-02c967d4b7f7'
  },
  {
    label: 'Louisiana',
    value: 'e4d80a5b-c8a1-4e81-870e-66190a494b3d'
  },
  {
    label: 'Maine',
    value: '5ceba8d2-47fa-4cc7-80ef-945611d2c2b0'
  },
  {
    label: 'Maryland',
    value: '726a3567-4910-4e01-b2b2-ef732e281861'
  },
  {
    label: 'Massachusetts',
    value: 'ffcd5253-a397-40e5-b8a9-9f7a90c15714'
  },
  {
    label: 'Michigan',
    value: '400ed892-fef2-412b-8be8-641b243e1598'
  },
  {
    label: 'Minnesota',
    value: '9dcf41f8-85fd-4a8c-800e-77463d555441'
  },
  {
    label: 'Mississippi',
    value: 'e1a297cf-abff-4ee6-830d-306491f681c9'
  },
  {
    label: 'Missouri',
    value: 'b21c1626-7fb0-44de-a988-48c9e81f4b47'
  },
  {
    label: 'Montana',
    value: '202e17d1-cd4b-4e2d-9f66-bd3edab2878a'
  },
  {
    label: 'Nebraska',
    value: '16e9c5f7-0d0a-4ed6-a903-caec807e972e'
  },
  {
    label: 'Nevada',
    value: 'c15a8ba2-4214-4c18-b5e6-c2fe767aa0b7'
  },
  {
    label: 'New Hampshire',
    value: '2e42a8f5-ac8f-4a21-bb34-e9faf0d3191c'
  },
  {
    label: 'New Jersey',
    value: '7452e77c-b307-4b28-a4d1-69f5e92ce069'
  },
  {
    label: 'New Mexico',
    value: 'd6c48a57-a547-4bcc-863b-50cad75a55cc'
  },
  {
    label: 'New York',
    value: 'ba132de8-8de5-4b20-a4d5-0511c1195a41'
  },
  {
    label: 'North Carolina',
    value: '67002a94-c57b-422a-b474-0282960dec0a'
  },
  {
    label: 'North Dakota',
    value: 'f6409526-a1f2-4b33-8338-936e9a87a534'
  },
  {
    label: 'Ohio',
    value: 'd8db7dfe-c361-447b-8702-04ef4ea71d55'
  },
  {
    label: 'Oklahoma',
    value: '84660b3e-a790-48ce-80c7-a1472af53190'
  },
  {
    label: 'Oregon',
    value: '68ad14f0-cc61-4e24-aa10-16dae30392a8'
  },
  {
    label: 'Pennsylvania',
    value: '4a8c4f97-355c-4a17-b6bf-fae9ffd9662a'
  },
  {
    label: 'Rhode Island',
    value: '1b2b6698-af2a-47f1-9d35-0ce12be0d4a5'
  },
  {
    label: 'South Carolina',
    value: 'c43866d4-83cc-44fa-b58d-32e489a37777'
  },
  {
    label: 'South Dakota',
    value: '3da76672-28b1-41e5-a05c-dd6f7126afba'
  },
  {
    label: 'Tennessee',
    value: '2a6856b7-db58-4109-a0d6-4dcf680e8a40'
  },
  {
    label: 'Texas',
    value: 'ba274d53-3f59-4418-a230-1ebeb0a97ca5'
  },
  {
    label: 'Utah',
    value: '8ab656aa-e7d3-426b-9829-fba3a491b7e2'
  },
  {
    label: 'Vermont',
    value: '46bfef76-a08f-49f4-b93b-3254f74f1ff5'
  },
  {
    label: 'Virginia',
    value: '7c506664-46bc-49a6-ba38-870b075fa567'
  },
  {
    label: 'Washington',
    value: 'fbc7c64a-3aaa-4bf1-a7cb-0dfb96b2ad35'
  },
  {
    label: 'West Virginia',
    value: 'd5087327-a18a-48cb-a1d6-69baa5e3b023'
  },
  {
    label: 'Wisconsin',
    value: '6c33509f-9194-4be5-9a80-ab776369b5f4'
  },
  {
    label: 'Wyoming',
    value: '5427eeda-25a1-458b-915c-49911bd62c7c'
  }
];
